import { render, staticRenderFns } from "./groundlights_task_edit.vue?vue&type=template&id=35b3047d&"
import script from "./groundlights_task_edit.vue?vue&type=script&lang=ts&"
export * from "./groundlights_task_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports